import { useState, useEffect } from 'react';
// import { Link, useHistory } from 'react-router-dom';
import GalleryModal from './GalleryModal'
import { BaseBtnLink } from '../../styledComponents/globalStyled'
import { Projectfooter } from '../../styledComponents/skillStyled'
import { CardStyle, CardImgStyle, CardBodyStyle } from '../../styledComponents/cardStyled'
import { LiaSteam } from "react-icons/lia";
export default function ImageCard(props: any) {
    const [TagOption, setTagOption] = useState("tag tag-blue");
    const [show, setShow] = useState(false);
    // console.log(props.info);
    useEffect(() => {
        switch (props.info.tags) {
            case "VR": setTagOption('tag tag-blue')
                break;
            case "2D": setTagOption('tag tag-red')
                break;
            case "3D": setTagOption('tag tag-green')
                break;
            default: setTagOption('tag tag-blue')
        }
    }, [props.info.tags]);

    return (
        <>
            <CardStyle>
                <div>
                    <CardImgStyle src={props.info.images[props.info.images.length - 1]} alt="card__image" width="600" height="200" />
                </div>
                <CardBodyStyle>
                    <span className={TagOption}>{props.info.tags}</span>
                    <h4>{props.info.title}</h4>
                    <p>{props.info.short_description}</p>
                </CardBodyStyle>
                <Projectfooter>
                    {props.info.steam ? <LiaSteam style={{ fontSize: "30px" }} /> : <></>}
                    <BaseBtnLink onClick={() => setShow(true)}  >View More</BaseBtnLink>
                    <GalleryModal info={props.info} show={show} onClose={() => setShow(false)}></GalleryModal>

                </Projectfooter>
            </CardStyle>

        </>
    );
}
